export enum EVinculoEmpresa {
    SemVinculo = 1,
    UmaEmpresa = 2,
    VariasEmpresas = 3,
}
